var map = {
	"./custom/app/navbar/navbar.component": [
		"23BF",
		68
	],
	"./dspace/app/navbar/navbar.component": [
		"COhy",
		87
	],
	"./uisdspace/app/navbar/navbar.component": [
		"DNgN",
		111
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Iuv1";
module.exports = webpackAsyncContext;